export const FlexBannerWrapper = {
  gap: ['0', '4'],
};
